export default __webpack_public_path__ + "/dist/images/market-pace-banner3.png.7822eebe8e3efd98943afa543bb8c537.png";